import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { CUSTOMER_STORIES_URL, testimonials } from '../data/homepage';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonials-title" className="bg-paper" data-id="element-229" data-mp="1n00o5v4lknrg">
      <div className="mx-auto max-w-[1280px] px-5 py-12 md:px-8 md:py-16 lg:py-20" data-id="element-230" data-mp="1mzsc25gatmhb">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between md:gap-12" data-id="element-231" data-mp="1r02rs9tw7r9d">
          <h2 id="testimonials-title" className="max-w-[560px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-232" data-mp="1d09t9sc4k6qu">
            A team clients keep coming back to.
          </h2>
          <a href={CUSTOMER_STORIES_URL} target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap text-[16px] font-bold text-ink underline decoration-ink/30 decoration-2 underline-offset-[6px] transition-colors duration-150 ease-out hover:decoration-ink md:self-end" data-id="element-233" data-mp="143izjml1p3zf">
            Read customer stories
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden data-id="element-234" data-mp="2q313ih5aqm08" />
            <span className="sr-only" data-id="element-235" data-mp="2q0ex4ku56cjl">(opens in a new tab)</span>
          </a>
        </div>

        <div className="mt-10 grid border-t border-rule md:grid-cols-2 md:divide-x md:divide-rule" data-id="element-236" data-mp="34tgqo1h9w411">
          {testimonials.map(t => <figure key={t.name} className="border-b border-rule py-8 last:border-b-0 md:border-b-0 md:px-10 md:py-10 md:first:pl-0 md:last:pr-0" data-id="element-237" data-mp="2c26srrus08ye">
              <blockquote className="text-[23px] font-bold leading-[1.35] text-ink md:text-[28px]" data-id="element-238" data-mp="2m0mlu0dd5saj">
                <p data-id="element-239" data-mp="2h22ybvj4g8g2">&ldquo;{t.quote}&rdquo;</p>
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 text-[15px] font-semibold text-muted" data-id="element-240" data-mp="2h3w7bhh7j4r8">
                <span className="h-0.5 w-6 bg-brand-orange" aria-hidden data-id="element-241" data-mp="1ci2bf6sttgr" />
                {t.name}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}